'use strict';

const CrossSellBait = require('../../cross_sell_bait/frontend/cross_sell_bait');

const MarkerTooltip = require('../../offers_map/frontend/marker_tooltip');

const initializeRichMarker = require('../../offers_map/frontend/vendor/richmarker-compiled.js');

require('./nearby_deals_map_carousel');

const TEMPLATES = {
  tooltip: require('../../offers_map/tooltip.html.mustache'),
  mapMarker: require('../../offers_map/map_marker.html.mustache'),
  dealsListAndMap: require('../deals_list_and_map.html.mustache'),
  nearby_deals_deals_list: require('../deals_list.html.mustache'),
};

if (!window.MPP.NearbyDealsMap) {
  window.MPP.NearbyDealsMap = {};
}

window.MPP.NearbyDealsMap.markers = [];
let merchantName = null;
let nearbyDealsMapCarousel = null;
let bounds = null;
const customMapStyles = [
  {
    featureType: 'all',
  },
  {},
  {
    featureType: 'poi.business',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
];

function addStarMarker(map, deal) {
  const hasDeals = $('#multiple-offers .mpp-deal-card').length > 0;
  const tooltipData = {
    isMainMarker: true,
    name: merchantName,
    nameAlreadyEscaped: true,
    formattedCategory: !hasDeals
      ? window.I18n.t('js.modules.nearby_deals.no_deal_available')
      : undefined,
  };
  const data = {
    label: '<span class="icon-star-filled"></span>',
    tooltipHtml: TEMPLATES.tooltip.render(tooltipData, TEMPLATES),
  };
  const $marker = $(TEMPLATES.mapMarker.render(data, TEMPLATES));
  const $tooltip = $marker.find('.marker-tooltip');
  const marker = new window.RichMarker({
    position: new window.google.maps.LatLng(deal.lat, deal.lon),
    map,
    draggable: false,
    shadow: false,
    content: $marker[0],
  });
  const tooltip = new MarkerTooltip({
    marker,
    $hoverElement: $marker.find('.marker-label'),
    $mapContainer: $('#map-canvas'),
    $tooltip,
    $marker,
  }); // This is necessary so that we only calculate the tooltip position after the map and marker are loaded

  setTimeout(() => tooltip.show(), 1000);
}

function addDealMarker(map, deal, label) {
  const data = {
    label,
    bhc: {
      marker: `deal:${deal.uuid}`,
    },
  };
  const $marker = $(TEMPLATES.mapMarker.render(data, TEMPLATES));
  const $label = $marker.find('.marker-label');
  $label.mouseenter(() => nearbyDealsMapCarousel.scrollToTile(label));
  new window.RichMarker({
    position: new window.google.maps.LatLng(deal.lat, deal.lon),
    map,
    draggable: false,
    shadow: false,
    content: $marker[0],
  });
  $marker
    .find('.marker-label')
    .click(() => nearbyDealsMapCarousel.goToDealPage(label));
  return $marker;
}

function setMarkers(map, deals) {
  if (deals.length > 1) {
    for (
      let i = 1, end = deals.length, asc = 1 <= end;
      asc ? i < end : i > end;
      asc ? i++ : i--
    ) {
      window.MPP.NearbyDealsMap.markers.push(addDealMarker(map, deals[i], i));
    }
  }

  addStarMarker(map, deals[0]);
}

function zoomToShowAllMarkers(map, nearbyDeals) {
  bounds = new window.google.maps.LatLngBounds();

  for (const deal of nearbyDeals) {
    bounds.extend(new window.google.maps.LatLng(deal.lat, deal.lon));
  }

  map.fitBounds(bounds);
}

window.googleMapsNearbyDealsInitialize = function() {
  initializeRichMarker();
  const mapContainer = $('#map-canvas');
  const centerLat = mapContainer.data('center-lat');
  const centerLng = mapContainer.data('center-lng');
  const nearbyDealsCarousel = $('.dealmap #nd-items');
  const nearbyDeals = nearbyDealsCarousel.children('.nearby-deal-tile');
  const nearbyDealsInfo = [];
  nearbyDealsInfo.push({
    lat: centerLat,
    lon: centerLng,
  });

  for (const deal of nearbyDeals) {
    nearbyDealsInfo.push({
      uuid: $(deal).data('uuid'),
      lat: $(deal).data('marker-lat'),
      lon: $(deal).data('marker-lng'),
    });
  }

  if (centerLat && centerLng && $('#map-canvas').length) {
    let left;
    const isDraggable =
      (left = $(document).width() > 480) != null
        ? left
        : {
            true: false,
          };
    const mapOptions = {
      center: new window.google.maps.LatLng(centerLat, centerLng),
      zoom: 12,
      zoomControl: true,
      zoomControlOptions: {
        style: window.google.maps.ZoomControlStyle.SMALL,
        position: window.google.maps.ControlPosition.LEFT_TOP,
      },
      mapTypeControl: false,
      draggable: isDraggable,
      scrollwheel: false,
      disableDefaultUI: true,
      mapTypeControlOptions: {
        mapTypeIds: [window.google.maps.MapTypeId.ROADMAP, 'mapStyle'],
      },
    };
    const map = new window.google.maps.Map(
      document.getElementById('map-canvas'),
      mapOptions
    );
    setMarkers(map, nearbyDealsInfo);
    zoomToShowAllMarkers(map, nearbyDealsInfo);
    const styledMap = new window.google.maps.StyledMapType(customMapStyles, {
      name: 'Styled Map',
    });
    map.mapTypes.set('mapStyle', styledMap);
    map.setMapTypeId('mapStyle');
  }
};

function removeNearbyDeals() {
  $('.mpp-container').addClass('no-explore-nearby');
  $('section.nearby-deals').remove();
}

function initialize() {
  nearbyDealsMapCarousel = new window.MPP.NearbyDealsMap.Carousel(
    '#nd-items',
    '#scrollable-list'
  );
  $('.nearby-deal-tile').on('click', function() {
    const dealUrl = $(this)
      .find('figcaption a')
      .attr('href');
    window.location = dealUrl;
    return window.location;
  }); // We hide the maps on phones, so don't load Google Maps if map is not present.

  if (!$('#map-canvas').length) {
    return;
  }

  Groupon.Utils.GoogleMaps.load(window.googleMapsNearbyDealsInitialize);
}

function fetchDealsAndRender({ showMap }, cb) {
  const merchantSlug = __guard__(
    window.location.pathname.match(/\/biz\/(.+)/),
    x => x[1]
  );

  if (merchantSlug == null) {
    removeNearbyDeals();
    return;
  }

  const request = $.get(`/merchant-page/nearby-deals/${merchantSlug}`, res => {
    const templateData = __guard__(
      res != null ? res.data : undefined,
      x1 => x1.nearbyDeals
    );

    if (templateData == null) {
      if (showMap) {
        removeNearbyDeals();
      }

      return;
    } // trigger an event so that Merchant Specials or other modules can use this data

    $('.mpp-container').trigger('nearby-deals-loaded', [templateData]);

    if (!showMap) {
      cb();
      return;
    }

    const $nearbyDeals = $('section.nearby-deals');
    const showBait = $nearbyDeals.data('show-bait') === true;
    const showingDealsText = I18n.translate(
      'js.modules.nearby_deals.showing_x_deals',
      {
        merchantName,
        totalDeals: templateData.markers && templateData.markers.length,
      }
    );

    templateData.translate = templateData.t = () => text =>
      window.I18n.translate(text);

    templateData.showBait = showBait;
    templateData.showingDealsText = showingDealsText;
    const nearbyDealsHtml = TEMPLATES.dealsListAndMap.render(
      templateData,
      TEMPLATES
    );
    const $nearbyDealsBox = $nearbyDeals.find('.nearby-deals-box');
    $nearbyDealsBox.html(nearbyDealsHtml);
    $nearbyDealsBox.removeClass('loading');
    $nearbyDealsBox.removeClass('gig-spinner');
    $nearbyDealsBox.removeClass('gig-spinner-brnd');
    const $showMore = $nearbyDeals.find('.show-more-nearby-deals');

    if ($showMore.length > 0) {
      $showMore.click(() => {
        $showMore.hide();
        return $nearbyDeals.find('.hide-until-show-more').slideDown();
      });
    }

    if (showBait && window.Modernizr.mq('(min-width: 768px)')) {
      setTimeout(
        () =>
          new CrossSellBait({
            $offers: $nearbyDeals,
          }),
        1000
      );
    }

    cb();
  });
  request.fail(() => {
    if (showMap) {
      removeNearbyDeals();
    }
  });
}

function moveWidgetInit(forceDesktop) {
  const $nearbyDeals = $('.mpp-container section.nearby-deals');
  const $desktopWrapper = $('.mpp-container .nearby-deals-desktop');
  const $mobileWrapper = $('.mpp-container .nearby-deals-mobile');

  if ($mobileWrapper.length > 0) {
    let debounceTimeout = null;
    $(window).on('resize', () => {
      if (debounceTimeout != null) {
        clearTimeout(debounceTimeout);
      }

      debounceTimeout = setTimeout(
        () =>
          moveWidget(
            $nearbyDeals,
            $desktopWrapper,
            $mobileWrapper,
            forceDesktop
          ),
        250
      );
    });

    moveWidget($nearbyDeals, $desktopWrapper, $mobileWrapper, forceDesktop);
  }
}

function moveWidget(
  $nearbyDeals,
  $desktopWrapper,
  $mobileWrapper,
  forceDesktop
) {
  // On Mobile, when the place has no offers, we move the Nearby Deals widget to the top.
  if (window.Modernizr.mq('(min-width: 768px)') || forceDesktop) {
    if ($desktopWrapper.find($nearbyDeals).length !== 0) {
      return;
    }

    $desktopWrapper.html($nearbyDeals);
    $mobileWrapper.find($nearbyDeals).remove();
  } else {
    if ($mobileWrapper.find($nearbyDeals).length !== 0) {
      return;
    }

    $mobileWrapper.html($nearbyDeals);
    $desktopWrapper.find($nearbyDeals).remove();
  }
}

window.MPP.NearbyDealsMap.init = function(options) {
  ({ merchantName } = options);
  const { forceDesktop } = options;
  return fetchDealsAndRender(options, () => {
    if (!options.showMap) {
      return;
    }

    initialize();
    moveWidgetInit(forceDesktop);
    window.GIG.Utils.truncateElements('#scrollable-list');
  });
};

$(() => {
  if (!$('.mpp-container').hasClass('has-nearby-deals')) {
    return;
  }

  const place = $('.mpp-container').data();
  const forceDesktop = $('.mpp-container').hasClass('force-desktop');
  window.MPP.NearbyDealsMap.init({
    showMap: $('.mpp-container .nearby-deals').length > 0,
    merchantName: place.placeName,
    forceDesktop,
  });
});

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null
    ? transform(value)
    : undefined;
}
